import(/* webpackMode: "eager", webpackExports: ["HomeView"] */ "D:\\FekerTech\\Shahen Website New\\src\\sections\\_home\\view\\home-view.jsx");
